export enum MentorProfileStatus {
  ACTIVE = "active",
  PAUSED_BY_MENTOR = "paused_by_mentor",
  PAUSED_BY_HEAD = "paused_by_head",
  PAUSED_BY_MASTER = "paused_by_master",
}

export interface MentorProfile {
  id: string;
  mentorId: string;

  createdAt: Date;
  updatedAt: Date;

  mentorUsername: string;
  description: string;

  imageUrl: string;

  status: MentorProfileStatus;
}
